import { Seo } from "@/components/common/Seo";
import { PageHero } from "@/components/common/PageHero";
import { Reveal } from "@/components/common/Reveal";
import { BRAND } from "@/data/site";
import { LEGAL_DOCS, LEGAL_EMAIL, LEGAL_EFFECTIVE } from "@/data/legal";

export default function Legal({ kind = "privacy" }) {
  const c = LEGAL_DOCS[kind] || LEGAL_DOCS.privacy;
  return (
    <>
      <Seo title={c.title} description={c.desc} />
      <PageHero label={c.label} titleLines={c.lines} accentIndex={1} />
      <section className="bg-paper py-24 md:py-32">
        <div className="container-px">
          <div className="max-w-3xl">
            <Reveal>
              <p className="font-mono text-xs uppercase tracking-[0.16em] text-teal">Effective {LEGAL_EFFECTIVE}</p>
            </Reveal>
            <Reveal delay={0.04}>
              <p className="mt-6 text-ink/60 leading-relaxed border-l-2 border-teal pl-5">{c.intro}</p>
            </Reveal>
          </div>
          <div className="mt-14 grid grid-cols-1 md:grid-cols-2 gap-x-12 lg:gap-x-16 gap-y-10">
            {c.sections.map(([h, body], i) => (
              <Reveal key={i} delay={0.02 * (i % 2)}>
                <div>
                  <h2 className="font-display font-700 text-xl flex gap-3">
                    <span className="font-mono text-teal text-sm mt-1">{String(i + 1).padStart(2, "0")}</span>
                    {h}
                  </h2>
                  <p className="mt-3 pl-8 text-ink/65 leading-relaxed">{body}</p>
                </div>
              </Reveal>
            ))}
          </div>
          <Reveal>
            <div className="mt-14 rounded-xl border border-ink/10 bg-white p-6">
              <p className="text-ink/70">Questions? Contact us at <a href={`mailto:${LEGAL_EMAIL}`} className="text-teal font-600">{LEGAL_EMAIL}</a>.</p>
              <p className="mt-2 text-sm text-ink/50">{BRAND.name} is operated by SevenM Technologies Private Limited.</p>
            </div>
          </Reveal>
          <p className="mt-10 font-mono text-xs uppercase tracking-[0.15em] text-ink/40">
            {BRAND.name} · {BRAND.domain}
          </p>
        </div>
      </section>
    </>
  );
}
